import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TimeIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.5288 6.97596V12.2404L17.024 14.9087L16.2788 16.1827L11.0144 12.9856V6.97596H12.5288ZM12 20.0288C13.4423 20.0288 14.7885 19.6603 16.0385 18.9231C17.2564 18.2179 18.2179 17.2564 18.9231 16.0385C19.6603 14.7885 20.0288 13.4423 20.0288 12C20.0288 10.5577 19.6603 9.21154 18.9231 7.96154C18.2179 6.74358 17.2564 5.78205 16.0385 5.07692C14.7885 4.33974 13.4423 3.97115 12 3.97115C10.5577 3.97115 9.21154 4.33974 7.96154 5.07692C6.74358 5.78205 5.78205 6.74358 5.07692 7.96154C4.33974 9.21154 3.97115 10.5577 3.97115 12C3.97115 13.4423 4.33974 14.7885 5.07692 16.0385C5.78205 17.2564 6.74358 18.2179 7.96154 18.9231C9.21154 19.6603 10.5577 20.0288 12 20.0288ZM12 2C13.8269 2 15.5176 2.45673 17.0721 3.37019C18.5785 4.23558 19.7644 5.42147 20.6298 6.92788C21.5433 8.48238 22 10.1731 22 12C22 13.8269 21.5433 15.5176 20.6298 17.0721C19.7644 18.5785 18.5785 19.7644 17.0721 20.6298C15.5176 21.5433 13.8269 22 12 22C10.1731 22 8.48238 21.5433 6.92789 20.6298C5.42147 19.7484 4.23558 18.5545 3.37019 17.0481C2.45673 15.4936 2 13.8109 2 12C2 10.1891 2.45673 8.50642 3.37019 6.95192C4.25161 5.4455 5.44551 4.25161 6.95192 3.37019C8.50642 2.45673 10.1891 2 12 2Z'
                fill='currentColor'
            />
        </>
    ),
})

TimeIcon.displayName = 'TimeIcon'
